import { useFormikContext } from 'formik';
import { debounce as _debounce, isEqual } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

export const useAutoSaveForm = ({ debounce = 1000 } = {}) => {
  const { values, submitForm, setErrors, isSubmitting } = useFormikContext();

  const [prevValues, setPrevValues] = useState(values);
  const [isUpdated, setUpdated] = useState(false);

  const persist = useCallback(
    _debounce(
      () => {
        submitForm().then(
          () => setUpdated(true),
          (error) => {
            setErrors(error?.response?.data?.errors);
          },
        );
      },
      debounce,
      { maxWait: 1500 },
    ),
    [debounce],
  );

  useEffect(() => {
    const isDirty = !isEqual(prevValues, values);

    if (isDirty) {
      setPrevValues(values);
      persist();
    }
  }, [values, persist, prevValues]);

  useEffect(() => {
    const timeout = setTimeout(() => setUpdated(false), 2000);

    return () => clearTimeout(timeout);
  }, [isUpdated]);

  return {
    isUpdated,
    isSubmitting,
  };
};
